import { AndFilters, OrFilters } from "features/Rsql/types/RsqlFilters";

export function buildRsqlString<Fields>(
  node?: OrFilters<Fields> | AndFilters<Fields>,
): string | undefined {
  if (node == undefined) return undefined;

  const operation = "or" in node ? "or" : "and";
  let rsqlString: string | undefined = undefined;
  const filters = node[operation];

  if (filters && filters.length > 0) {
    const parts: string[] = [];

    filters.forEach((node) => {
      if (Array.isArray(node)) {
        const [field, comparison, rightOperand] = node;
        if (Array.isArray(rightOperand)) {
          // e.g.: id=in=(1,2,3)
          if (rightOperand.length > 0) {
            parts.push(`${field}${comparison}(${rightOperand.join(",")})`);
          }
        } else {
          // e.g.: id==1
          parts.push(`${field}${comparison}${rightOperand}`);
        }
      } else if (node) {
        // Recursively construct nested condition
        const newNode = buildRsqlString<Fields>(node);
        if (newNode) {
          parts.push(`(${newNode})`);
        }
      }
    });

    if (parts.length > 0) {
      rsqlString = parts.join(` ${operation} `);
    }
  }

  return rsqlString;
}
